// n.b. this needs to be a CommonJS module in order to work in Node.js

module.exports = {
    STATE_CLASSES: {
        // UI
        ACTIVE: 'is-active',
        INACTIVE: 'is-inactive',
        ENABLED: 'is-enabled',
        DISABLED: 'is-disabled',
        VISIBLE: 'is-visible',
        HIDDEN: 'is-hidden',
        COLLAPSED: 'is-collapsed',
        EXPANDED: 'is-expanded',
        COMPACT: 'is-compact',
        VALID: 'is-valid',
        INVALID: 'is-invalid',
        SELECTED: 'is-selected',
        MATCHING: 'is-matching',
        HIGHLIGHTED: 'is-highlighted',
        HOVERED: 'is-hovered',
        EMPTY: 'is-empty',

        // context menu
        COPYING: 'is-copying',
        CUTTING: 'is-cutting',
        PASTING: 'is-pasting',

        // editor
        EDITING: 'is-editing',
        PREVIEW: 'is-preview',
        GUIDED: 'is-guided',
        DESKTOP: 'is-desktop',
        LAPTOP: 'is-laptop',
        TABLET: 'is-tablet',
        MOBILE: 'is-mobile',
        SELECTED_ELEMENT: 'is-selected-element',
        STATIC: 'is-static',
        LOCKED: 'is-locked',
        NEW: 'is-new',

        // element
        HEADING: 'is-heading',
        PARAGRAPH: 'is-paragraph',
        BUTTON: 'is-button',
    },
};
